import "./Quotation.scss";
import { useEffect, useState } from "react";
import moment from "moment";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import quotationImg from "./../../../../../src/assets/img/service/quotation.png";
import PrintDocumentTemplate from "../../../../Components/PrintDocumentTemplate/PrintDocumentTemplate";
import { Icon } from "@mui/material";
import { useTranslation } from "react-i18next";
const QuotationLogoComponent = ({ logo }) => {
  return (
    <div className="LogoArea">
      {logo ? <img className="Logo" alt="Logo" src={logo} /> : null}
    </div>
  );
};

export const Quotation = () => {
  // const printData = JSON.parse(sessionStorage.getItem("printData"));
  const serviceOrderData = JSON.parse(
    sessionStorage.getItem("serviceOrderData"),
  );
  const { t } = useTranslation();
  const [logo, setLogo] = useState(null);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      const settingsResp = await GlobalAuthFetch({
        path: "/settings",
        disableError: true,
      });
      const data = settingsResp?.payload?.data || [];
      const formattedSettings = data.reduce((acc, item) => {
        acc[item.name] = item.value;
        return acc;
      }, {});
      setLogo(formattedSettings.LOGO);
      setSettings(formattedSettings);
    };

    loadData();
  }, []);

  if (!settings) return null;

  return (
    <PrintDocumentTemplate
      fileName={`Rozliczenie umowy: "-"`}
      printDataOptimaId={{}}
      printData={{}}
      dataToXls={[]}
      colorRanges={[
        { range: [1, 1], header: "FFFF00", data: "FFEEEE" },
        { range: [2, 2], header: "00FF00", data: "EEFFEE" },
      ]}
      documentType="ServiceOrder"
      usersToSendEmail={[]}
    >
      {[
        <div>
          <div className="TargetPrintQuotationAreaFrom">
            <div className="HeaderArea">
              <QuotationLogoComponent logo={logo} />
              <div className="DateArea">
                <span>{settings.COMPANY_NAME}</span>
                <span>
                  {`${t("global:service.str")}`} {settings.COMPANY_ADDRESS},{" "}
                  {settings.COMPANY_POST_CODE} {settings.COMPANY_CITY}
                </span>
                <span>
                  {`${t("global:service.phone")}`} {settings.COMPANY_PHONE}
                </span>
                <span>{settings.WEBSITE}</span>
              </div>
            </div>

            <span className="Date">
              {settings.COMPANY_CITY}
              {moment(serviceOrderData?.createdAt).format("DD-MM-YYYYr")}
            </span>
            <div className="quotation-details-container">
              <div className="red-separator">
                <div class="section-title">{`${t(
                  "global:service.servicePricing",
                )}`}</div>
                <div class="section-line"></div>
              </div>
              <div className="quotation-details">
                <div className="quotation-left">
                  <section className="info-block">
                    <span className="info-icon">
                      <Icon>art_track</Icon>
                    </span>
                    <h3 className="info-title">
                      {`${t("global:service.client")}`}
                    </h3>
                    <p className="info-value">
                      {serviceOrderData?.device?.client?.name}
                    </p>
                  </section>

                  <section className="info-block mt-5">
                    <span className="info-icon">
                      <Icon>art_track</Icon>
                    </span>
                    <h3 className="info-title">
                      {`${t("global:service.device")}`}
                    </h3>

                    <div className="kv">
                      <span>{`${t("global:service.modelName")}`}</span>
                      <span>
                        {
                          serviceOrderData?.device?.printerModel?.manufacturer
                            ?.entryName
                        }{" "}
                        {serviceOrderData?.device?.printerModel?.modelName}
                      </span>
                    </div>
                    <div className="kv">
                      <span>{`${t("global:service.sn")}`}</span>
                      <span> {serviceOrderData?.device?.serialNumber}</span>
                    </div>
                    <div className="kv">
                      <span>{`${t("global:service.id")}`}</span>
                      {/* index zlecenia */}
                      <span>{serviceOrderData?.index}</span>
                    </div>
                  </section>
                </div>
                <div className="quotation-right">
                  <section className="info-block">
                    {/* Zakres naprawy */}
                    <h3 className="info-title">{`${t(
                      "global:service.scopeOfRepair",
                    )}`}</h3>

                    <div className="row grey-separator">
                      {/* Części, materiały eksploatacyjne: */}
                      <span>{`${t("global:service.PartsConsumables")}`}</span>
                      <span className="grey-text">0.00 PLN + 23% VAT</span>
                    </div>

                    <div className="row">
                      {/* Usługi */}
                      <span>{`${t("global:service.services")}`}</span>
                      <span className="grey-text">430.00 PLN + 23% VAT</span>
                    </div>
                    <div className="row grey-separator">
                      <span className="grey-text">{`${t(
                        "global:service.scope",
                      )}`}</span>
                    </div>

                    <div className="row grey-separator">
                      {/* Transport */}
                      <span>{`${t("global:service.transport")}`}</span>
                      <span className="grey-text">0.00 PLN + 23% VAT</span>
                    </div>

                    <div className="row total">
                      {/* Razem */}
                      <span>{`${t("global:service.total")}`}</span>
                      <span>430.00 PLN + 23% VAT</span>
                    </div>

                    <div className="row">
                      <span>{`${t("global:service.valuationDate")}`}</span>
                      <span className="grey-text">do 2025-11-23</span>
                    </div>

                    <p className="note">
                      {`${t("global:service.serviceWarrantyTime")}`}
                    </p>
                  </section>

                  <section className="info-block">
                    {/* Uwagi z wyceny */}
                    <h3 className="info-title">{`${t(
                      "global:service.comments",
                    )}`}</h3>
                    <span className="grey-text">Brak uwag</span>
                  </section>
                </div>
              </div>
              <div className="acceptance-container">
                <div class="acceptance">
                  {/* Akceptacja */}
                  <span class="text">{`${t(
                    "global:service.acceptance",
                  )}`}</span>
                  {/* Data */}
                  <span class="date">{`${t("global:service.date")}`}</span>
                  {/* Podpis */}
                  <span class="signature">{`${t(
                    "global:service.signature",
                  )}`}</span>
                </div>
              </div>
              <div className="red-separator">
                <div class="section-line"></div>
              </div>
              <div className="img-section">
                <img className="img" src={quotationImg} alt="Quotation Img" />
                <p className="info-text-value">
                  {" "}
                  {settings.SERVICE_QUOTATION_MARKETING_TEXT}
                </p>
              </div>
              <div className="red-separator">
                <div class="section-line"></div>
              </div>
              <div>
                <section className="info-block">
                  <h3 className="info-title">
                    {`${t("global:service.contact")}`}
                  </h3>
                  <p className="info-text-value">
                    {settings.SERVICE_QUOTATION_FOOTER_TEXT}
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>,
      ]}
    </PrintDocumentTemplate>
  );
};
